module.exports = __webpack_public_path__ + "static/4-170eccdc459de59f078bac02c019ccf9.png";